import { Patient } from '@/types/patient';
import { DateTime } from 'luxon';
import { Civility } from '@/types/civility';

export const getCivilityLabel = (object: { civility: Civility }) => {
  switch (object.civility) {
    case Civility.FEMALE:
      return 'Femme';
    case Civility.MALE:
      return 'Homme';
    case Civility.NONBINARY:
      return 'Ne souhaite pas se prononcer';
  }
};

export const getPatientAge = (patient: Patient) => {
  const { birth_year, birth_month, birth_day } = patient || {};

  if (!birth_year || !birth_month || !birth_day) {
    return null;
  }

  const birthDate = DateTime.fromObject({
    year: +birth_year,
    month: +birth_month,
    day: +birth_day,
  });

  return Math.floor(DateTime.now().diff(birthDate, 'years').years);
};

export const getBirthdayLabel = (patient: Patient) => {
  const { birth_year, birth_month, birth_day } = patient || {};

  return `${birth_day}/${birth_month}/${birth_year}`;
};
